import start from './src/start';
import esa_cards_listeners from './src/esa-cards-listeners';

import {rotating_text} from './src/rotating-text';
import {splash_video_player} from './src/splash-video-player';
import {buildAllRatingStars} from '../globali/rating-stars';

import {odometer} from '../globali/odometer';


start();
splash_video_player();
rotating_text();
esa_cards_listeners(); // include tooltips
buildAllRatingStars();

document.querySelectorAll('.odometer').forEach(item => {
  new odometer(item);
});
